import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import './assets/css/tailwind.css'
// import './registerServiceWorker'
import VueSplide from '@splidejs/vue-splide'
import '@splidejs/splide/dist/css/splide.min.css'

Vue.config.productionTip = false

Vue.use(VueSplide);

new Vue({
  render: h => h(App),
}).$mount('#app')
